import apiClient from '../apiClient';
import { LoginRequest, LoginResponse, StaffInfo } from '../../types/entity/auth';
import { BaseResponse } from '../../types/base.dto';

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<BaseResponse<LoginResponse>>('/login', credentials);
    return response.data.data;
  },
  
  logout: () => {
    localStorage.removeItem('auth.profile');
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('staff');
  },

  getProfile: async (id: number): Promise<StaffInfo> => {
    // Re-use StaffProfileResponse structure which matches StaffInfo
    const response = await apiClient.get<BaseResponse<StaffInfo>>(`/staff/${id}`);
    return response.data.data;
  },
};
